import {PackageCategory} from 'types/enums/PackageCategory'

const categoriesRequiringChildren: ReadonlySet<string> = new Set([
    PackageCategory.MegaFunSchool,
    PackageCategory.School,
    PackageCategory.SchoolTrophy,
    PackageCategory.Kinder,
    PackageCategory.HappyKids,
    PackageCategory.HappyKidsPlus,
    PackageCategory.Action,
])

/**
 * Regular offer packages do not have separate child package items. For those
 * categories children consume an adult package position, while child/family
 * categories keep the original participant split.
 */
export const shouldCountOfferChildrenAsAdults = (category: string): boolean =>
    !categoriesRequiringChildren.has(category)

/**
 * Keep adult packages available when children join the group. Categories made
 * specifically for children still require at least one child, while a family
 * ticket accepts at most two adults.
 */
export const isOfferCategoryAvailableForParticipants = (
    category: string,
    adults: number,
    children: number
): boolean => {
    const adultCount = Number(adults) || 0
    const childCount = Number(children) || 0

    if (!categoriesRequiringChildren.has(category)) return true
    if (childCount < 1) return false

    return category !== PackageCategory.Action || adultCount <= 2
}
